import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { PilotControlledLightingService } from '../service/pilot-controlled-lighting.service';
import { MatDialogRef } from '@angular/material';
var DeletePilotControlledLightingComponent = /** @class */ (function () {
    function DeletePilotControlledLightingComponent(_matDialogRef, data, _pclService) {
        this._matDialogRef = _matDialogRef;
        this._pclService = _pclService;
        this.isLoading = false;
        this.pclId = data.pclId;
        this.airportId = data.airportId;
    }
    DeletePilotControlledLightingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeletePilotControlledLightingComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeletePilotControlledLightingComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._pclService.deletePCL(this.airportId, this.pclId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeletePilotControlledLightingComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeletePilotControlledLightingComponent;
}());
export { DeletePilotControlledLightingComponent };
